"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _amazonCognitoIdentityJs = require("amazon-cognito-identity-js");

var _styles = require("@material-ui/core/styles");

var _defaultTheme = _interopRequireDefault(require("ra-ui-materialui/lib/defaultTheme"));

var _layout = require("ra-ui-materialui/lib/layout");

var _reactAdmin = require("react-admin");

var _classnames = _interopRequireDefault(require("classnames"));

var _core = require("@material-ui/core");

var _icons = require("@material-ui/icons");

var _amplifyHandlers = require("../amplifyHandlers");

var _isNewPasswordRequired = _interopRequireDefault(require("../util/isNewPasswordRequired"));

var _LoginForm = _interopRequireDefault(require("./LoginForm"));

var _pageStyles = _interopRequireDefault(require("./styles/pageStyles"));

var _ChangePasswordForm = _interopRequireDefault(require("./ChangePasswordForm"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sanitizeRestProps = function sanitizeRestProps(_ref) {
  var classes = _ref.classes,
      className = _ref.className,
      location = _ref.location,
      title = _ref.title,
      array = _ref.array,
      theme = _ref.theme,
      dispatch = _ref.dispatch,
      staticContext = _ref.staticContext,
      rest = _objectWithoutProperties(_ref, ["classes", "className", "location", "title", "array", "theme", "dispatch", "staticContext"]);

  return rest;
};

var Login = function Login(_ref2) {
  var classes = _ref2.classes,
      className = _ref2.className,
      overridePasswordValidation = _ref2.overridePasswordValidation,
      loginFormStyle = _ref2.loginFormStyle,
      passwordFormStyle = _ref2.passwordFormStyle,
      loginIcon = _ref2.loginIcon,
      rest = _objectWithoutProperties(_ref2, ["classes", "className", "overridePasswordValidation", "loginFormStyle", "passwordFormStyle", "loginIcon"]);

  var _useState = (0, _react.useState)('login'),
      _useState2 = _slicedToArray(_useState, 2),
      step = _useState2[0],
      setStep = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      cognitoUser = _useState4[0],
      setCognitoUser = _useState4[1];

  var raLogin = (0, _reactAdmin.useLogin)();
  var notify = (0, _reactAdmin.useNotify)();

  var handleChangePassword = function handleChangePassword(auth) {
    var history = rest.history;
    return (0, _amplifyHandlers.forceChangePassword)(_objectSpread({
      cognitoUser: cognitoUser
    }, auth)).then(function (result) {
      if (result instanceof _amazonCognitoIdentityJs.CognitoUser) {
        return history.push('/');
      }

      throw new Error("Password change unsuccessful ".concat(result));
    }).catch(function (error) {
      console.error('Change password failure', error);
      return notify("".concat(error.message || error), 'warning');
    });
  };

  var handleLogin =
  /*#__PURE__*/
  function () {
    var _ref3 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee(auth) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", raLogin(auth).catch(function (error) {
                // Check that the error isn't due to new password required
                if ((0, _isNewPasswordRequired.default)(error)) {
                  setCognitoUser(error);
                  setStep('change_password');
                  return;
                }

                return notify("".concat(error.message || error), 'warning');
              }));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleLogin(_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  return _react.default.createElement("div", _extends({
    className: (0, _classnames.default)(classes.main, className)
  }, sanitizeRestProps(rest)), _react.default.createElement(_core.Card, {
    className: classes.card
  }, _react.default.createElement("div", {
    className: classes.avatar
  }, _react.default.createElement(_core.Avatar, {
    className: classes.icon
  }, loginIcon || _react.default.createElement(_icons.Lock, null))), step === 'login' ? _react.default.createElement(_LoginForm.default, {
    requestLogin: handleLogin,
    classes: loginFormStyle
  }) : step === 'change_password' ? _react.default.createElement(_ChangePasswordForm.default, {
    classes: passwordFormStyle,
    requestChangePassword: handleChangePassword,
    overridePasswordValidation: overridePasswordValidation
  }) : null), _react.default.createElement(_layout.Notification, null));
};

Login.propTypes = {
  className: _propTypes.default.string,
  classes: _propTypes.default.object,
  passwordFormStyle: _propTypes.default.object,
  loginFormStyle: _propTypes.default.object,
  meta: _propTypes.default.object,
  theme: _propTypes.default.object,
  overridePasswordValidation: _propTypes.default.func,
  loginIcon: _propTypes.default.object
};
Login.defaultProps = {
  className: null,
  classes: null,
  passwordFormStyle: null,
  loginFormStyle: null,
  meta: null,
  theme: _defaultTheme.default,
  overridePasswordValidation: null,
  loginIcon: null
};

var _default = (0, _styles.withStyles)(_pageStyles.default)(Login);

exports.default = _default;